import { IModel, Model, ModelRecord } from '@common/models/Model';
import {
  IProactivePrescriptionRuleItemModel,
  ProactivePrescriptionRuleItemModel,
} from '@common/models/ProactivePrescriptionRuleItemModel';

export interface IProactivePrescriptionRuleModel extends IModel {
  proactivePrescriptionRuleId: number;
  name: string;
  speciesId: number;
  helpText: string;
  clinicTraitId?: number;
  hospitalTraitId?: number;
  proactivePrescriptionRuleItems: IProactivePrescriptionRuleItemModel[];
}

export class ProactivePrescriptionRuleModel
  extends Model
  implements ModelRecord<IProactivePrescriptionRuleModel>
{
  proactivePrescriptionRuleId: number;
  name: string;
  speciesId: number;
  helpText: string;
  clinicTraitId: number;
  hospitalTraitId: number;
  proactivePrescriptionRuleItems: IProactivePrescriptionRuleItemModel[] = [];

  constructor(params?: Partial<IProactivePrescriptionRuleModel>) {
    super(params);
    this.proactivePrescriptionRuleId = params?.proactivePrescriptionRuleId || 0;
    this.name = params?.name || '';
    this.speciesId = params?.speciesId || 0;
    this.helpText = params?.helpText || '';
    this.clinicTraitId = params?.clinicTraitId ?? 0;
    this.hospitalTraitId = params?.hospitalTraitId ?? 0;
    _.map(
      _.orderBy(
        params?.proactivePrescriptionRuleItems,
        (v) => v.proactivePrescriptionRuleItemId,
      ),
      (content) => {
        this.proactivePrescriptionRuleItems.push(
          new ProactivePrescriptionRuleItemModel(content),
        );
      },
    );
  }
}
